var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"es-train-information-card",class:(_vm.isChange == 1 && 'ticket-change')},[_vm._t("default"),_vm._t("divider")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }